module.exports = __webpack_public_path__ + "img/13.dd836c38.jpg";